import React from 'react';
import { makeStyles, TableCell } from '@material-ui/core';

import { colors } from 'src/constants';
import { formatCurrency } from 'src/utils';

interface QuotationPromoPriceCellProps {
  srp?: number;
}

const width = 170;

const useStyles = makeStyles(
  () => ({
    root: {
      maxWidth: width,
      minWidth: width
    },
    pesoSign: {
      padding: 0,
      color: colors.black,
      fontWeight: 400,
      fontSize: 14,
      paddingTop: 1
    },
    input: {
      fontSize: 14,
      verticalAlign: 'text-top'
    },
    amount: {
      fontWeight: 500
    },
    showSRPInput: {
      color: colors.warning
    }
  }),
  { index: 999 }
);

const StandarRetailPrice = ({ srp = 0 }: QuotationPromoPriceCellProps) => {
  const classes = useStyles();

  return (
    /* Do not show promo price input if showSRP is enabled. */
    <TableCell className={classes.root} onClick={(e) => e.stopPropagation()}>
      {formatCurrency(srp)}
    </TableCell>
  );
};

export const QuotationSRPCell = React.memo(StandarRetailPrice);
